// export const baseUrl = 'http://localhost:8000/api/v3';
export const baseUrl = 'https://api-v3.learn-quran.co/api/v3';

// the constants below based are needed in this project
export const lqtajwid = 'lqtajwid';
export const lqtafsir = 'lqtafsir';
export const qtv = 'qtv';
export const android = 'android';
export const ios = 'ios';

// the constants below based on table backend database: total_impacts table
export const users_lqtajwid = 'users_lqtajwid';
export const countries_lqtajwid = 'countries_lqtajwid';
export const star_rating_google_play_store_lqtajwid = 'star_rating_google_play_store_lqtajwid';
export const star_rating_apple_app_store_lqtajwid = 'star_rating_apple_app_store_lqtajwid';
export const users_lqtafsir = 'users_lqtafsir';
export const countries_lqtafsir = 'countries_lqtafsir';
export const star_rating_google_play_store_lqtafsir = 'star_rating_google_play_store_lqtafsir';
export const star_rating_apple_app_store_lqtafsir = 'star_rating_apple_app_store_lqtafsir';
export const minutes_of_usage_qtv = 'minutes_of_usage_qtv';
export const countries_qtv = 'countries_qtv';
export const star_rating_google_play_store_qtv = 'star_rating_google_play_store_qtv';

// default value
export const minutes_of_usage_qtv_default = 20000000;
export const users_lqtajwid_default = 4000000;
export const users_lqtafsir_default = 4000000;
export const countries_lqtajwid_default = 190;
export const countries_lqtafsir_default = 180;
export const countries_qtv_default = 150;
export const stars_lqtajwid_android_default = 4.8;
export const stars_lqtajwid_ios_default = 4.7;
export const stars_lqtafsir_android_default = 4.9;
export const stars_lqtafsir_ios_default = 5.0;
export const stars_qtv_android_default = 4.7;
export const stars_qtv_ios_default = 5.0;